export default "__VITE_ASSET__77c8c55b__"